<automatic-debit-breadcrumb [items]="breadcrumbItems"></automatic-debit-breadcrumb>

<div class="file-page-ret mt-5">
    <!-- Card do Arquivo Importado -->
    <div class="card shadow-sm">
        <div class="card-header bg-file-header text-white d-flex justify-content-between align-items-center">
            <h5 class="mb-0 text-center"><i class="fa fa-file mr-2 text-white"></i> Arquivos de Retorno</h5>
            <button (click)="navigateTo('/automatic-debit/ret/import')" class="btn btn-success">
                <span class="fa fa-file text-white fa-2x"></span>
                Importar arquivo
            </button>
        </div>
        <div class="card-body">
            <div class="row">
                <div class="col-md-2">
                    <label>Data Inicial:</label>
                    <input type="date" class="form-control" [(ngModel)]="beginDateStr" required />
                </div>
                <div class="col-md-2">
                    <label>Data Final:</label>
                    <input type="date" class="form-control" [(ngModel)]="endDateStr" required />
                </div>
                <div class="col-md-2">
                    <br />
                    <button (click)="btnSearch()" class="btn btn-success">
                        Buscar
                        <span class="mx-3 fa fa-search text-white"> </span>
                    </button>
                </div>
            </div>

            <hr />
            <div class="automatic-debit-table-component" *ngIf="fileListPaginated.length > 0">
                <table class="table table-striped table-hover">
                    <thead>
                        <tr>
                            <th scope="col">Data</th>
                            <th scope="col">Arquivo</th>
                            <th scope="col">Qtd Itens</th>
                            <th scope="col">Usuário</th>
                            <th scope="col">Status</th>
                            <th scope="col"></th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let file of fileListPaginated">
                            <td>{{ file.generatedDate | date: 'dd/MM/yyyy' }}</td>
                            <td>{{ file.fileName }}</td>
                            <td>{{ file.lines.length }}</td>
                            <td>{{ file.userName }}</td>
                            <td>{{ file.statusFileName }}</td>

                            <td class="float-right">
                                <button (click)="downloadFile(file)" class="btn btn-primary btn-sm">
                                    <i class="flaticon-download-1 text-white"></i>
                                </button>

                                <button (click)="selectFile(file.id)" class="btn btn-success btn-sm mx-3">
                                    <i class="fa fa-angle-double-right text-white"></i>
                                </button>

                                <button (click)="deleteFile(file.id)" class="btn btn-danger btn-sm mx-3">
                                    <i class="fa fa-times text-white"></i>
                                </button>
                            </td>
                        </tr>
                    </tbody>
                </table>

                <div class="d-flex justify-content-between p-2">
                    <label
                        >Total: <strong> {{ fileListPaginated?.length }} </strong></label
                    >
                </div>
            </div>
        </div>
    </div>
</div>
